import React from "react";
import { Card, CardContent, Chip, Grid, Stack, Typography } from "@mui/material";
import SensorsRoundedIcon from "@mui/icons-material/SensorsRounded";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import MonitorHeartRoundedIcon from "@mui/icons-material/MonitorHeartRounded";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

export default function TelemetrySummary({
  totalDevices = 0,
  lastUpdated = "",
  normalCount = 0,
  alertCount = 0,
}) {
  return (
    <Card
      elevation={0}
      sx={{
        mb: 3,
        borderRadius: 4,
        border: "1px solid #dbe4ea",
        background: "linear-gradient(135deg, #0f2f35 0%, #12424a 100%)",
        color: "#fff",
        boxShadow: "0 16px 42px rgba(0,0,0,0.12)",
      }}
    >
      <CardContent sx={{ p: { xs: 2, md: 3 } }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h4" sx={{ fontWeight: 800, mb: 0.5 }}>
              Live Telemetry Monitoring
            </Typography>
            <Typography sx={{ color: "rgba(255,255,255,0.82)" }}>
              Real-time fluid monitoring dashboard for connected devices
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={1.2}
              justifyContent={{ xs: "flex-start", md: "flex-end" }}
              flexWrap="wrap"
            >
              <Chip
                icon={<SensorsRoundedIcon sx={{ color: "#fff !important" }} />}
                label={`Devices: ${totalDevices}`}
                sx={chipStyle}
              />
              <Chip
                icon={<MonitorHeartRoundedIcon sx={{ color: "#fff !important" }} />}
                label={`Normal: ${normalCount}`}
                sx={chipStyle}
              />
              <Chip
                icon={<WarningAmberRoundedIcon sx={{ color: "#fff !important" }} />}
                label={`Alerts: ${alertCount}`}
                sx={chipStyle}
              />
              <Chip
                icon={<AccessTimeRoundedIcon sx={{ color: "#fff !important" }} />}
                label={lastUpdated ? `Updated: ${lastUpdated}` : "Waiting..."}
                sx={chipStyle}
              />
            </Stack>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

const chipStyle = {
  color: "#fff",
  bgcolor: "rgba(255,255,255,0.12)",
  border: "1px solid rgba(255,255,255,0.18)",
  fontWeight: 700,
};